<template>
  <div>
    <SidebarSearch
      @submit="submitForm"
      @clear="clearForm"
      :isLoading="isSearching"
    >
      <SearchCollapse
        :expanded="true"
        title="Filtros"
      >
        <NxSelectTipoQuadro
          label="CRM"
          :required="true"
          @update:value="handleSelectUpdate('tipoBoard', $event)"
        />
        <NxSelectQuadro
          label="Quadro"
          :required="true"
          :tipoQuadro="form.tipoBoard"
          @update:value="handleSelectUpdate('boardId', $event)"
        />
        <NxSelectQuadroColuna
          :boardId="form.boardId"
          @update:value="handleSelectUpdate('boardColumnId', $event)"
        />
        <NxInputName
          label="Nome do Associado"
          @update:value="handleInputUpdate('nomeAssociado', $event, false)"
        />
        <NxInputDocument
          label="CPF/CNPJ"
          @update:value="handleInputUpdate('cpfCnpj', $event)"
        />
        <NxSelectFuncionario
          label="Responsável"
          :variable="employeeTypes.RESPONSAVEL"
          @update:value="handleSelectUpdate('responsavelId', $event)"
        />
        <NxSelectPA
          label="PA"
          @update:value="handleSelectUpdate('paId', $event)"
        />
        <NxInputDateRange
          label="Período:"
          :required="true"
          :showError="showPeriodoError"
          @update:InitialValue="
            handleInputDateUpdate('periodoInicial', $event, false)
          "
          @update:FinalValue="handleInputDateUpdate('periodoFinal', $event, false)"
        />
      </SearchCollapse>
    </SidebarSearch>
  </div>
</template>

<script>
import {
  NxInputDateRange,
  NxInputDocument,
  NxInputName
} from '@/components/nexum/components/custom-inputs/index.js'
import {
  NxSelectFuncionario,
  NxSelectPA,
  NxSelectQuadro,
  NxSelectQuadroColuna,
  NxSelectTipoQuadro
} from '@/components/nexum/components/custom-selects/index.js'
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'
import employeeTypes from '@/enums/enumEmployeeTypes.js'

export default {
  name: 'SidebarRelatorioMovimentacao',
  components: {
    SidebarSearch,
    SearchCollapse,
    NxSelectTipoQuadro,
    NxSelectQuadro,
    NxSelectQuadroColuna,
    NxInputName,
    NxInputDocument,
    NxSelectFuncionario,
    NxSelectPA,
    NxInputDateRange
  },
  props: {
    isSearching: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {
        tipoBoard: null,
        boardId: null,
        boardColumnId: null,
        nomeAssociado: null,
        cpfCnpj: null,
        responsavelId: null,
        paId: null,
        periodoInicial: null,
        periodoFinal: null
      },
      employeeTypes: employeeTypes,
      maxDays: null,
      showPeriodoError: false
    }
  },
  watch: {
    'form.tipoBoard' (newVal, oldVal) {
      if (newVal !== oldVal && oldVal !== null) {
        this.form.boardId = null
        this.form.boardColumnId = null
      }
    },
    'form.boardId' (newVal, oldVal) {
      if (newVal !== oldVal && oldVal !== null) {
        this.form.boardColumnId = null
      }
    },
    'form.periodoInicial' (newVal) {
      if (newVal && this.showPeriodoError) {
        this.showPeriodoError = false
      }
    },
    'form.periodoFinal' (newVal) {
      if (newVal && this.showPeriodoError) {
        this.showPeriodoError = false
      }
    }
  },
  methods: {
    submitForm () {
      const isTipoBoardValid = Array.isArray(this.form.tipoBoard)
        ? this.form.tipoBoard.length > 0
        : !!this.form.tipoBoard

      const isBoardIdValid = Array.isArray(this.form.boardId)
        ? this.form.boardId.length > 0
        : !!this.form.boardId

      if (!isTipoBoardValid || !isBoardIdValid) {
        this.$toast.error('Preencha os campos obrigatórios antes de continuar.', 'Atenção')
        return
      }

      if (!this.form.periodoInicial || !this.form.periodoFinal) {
        this.showPeriodoError = true
        this.$toast.error('Os campos de período são obrigatórios.', 'Atenção')
        return
      }

      this.showPeriodoError = false

      if (new Date(this.form.periodoFinal) < new Date(this.form.periodoInicial)) {
        this.$toast.error('A data final não pode ser menor que a data inicial.', 'Atenção')
        return
      }

      if (this.maxDays !== null) {
        const diffTime = Math.abs(new Date(this.form.periodoFinal) - new Date(this.form.periodoInicial))
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

        if (diffDays > this.maxDays) {
          this.$toast.error(
            `O período máximo permitido é de ${this.maxDays} dias. Período selecionado: ${diffDays} dias.`,
            'Atenção'
          )
          return
        }
      }

      if (this.form.cpfCnpj) {
        this.form.cpfCnpj = this.form.cpfCnpj.toString().replace(/[^\d]+/g, '')
      }
      this.$nextTick(() => {
        this.$emit('search', this.form)
      })
    },
    extractMaxDaysFromError (errorMessage) {
      const match = errorMessage.match(/período máximo permitido é de (\d+) dias/i)
      if (match && match[1]) {
        return parseInt(match[1], 10)
      }
      return null
    },
    clearForm () {
      this.$root.$emit('clearForm')
      this.form = {
        tipoBoard: null,
        boardId: null,
        boardColumnId: null,
        nomeAssociado: null,
        cpfCnpj: null,
        responsavelId: null,
        paId: null,
        periodoInicial: null,
        periodoFinal: null
      }
      this.showPeriodoError = false
    },
    handleSelectUpdate (fieldName, selectedValue) {
      if (selectedValue === null || selectedValue === undefined) {
        this.clearField(fieldName)
        return
      }
      if (Array.isArray(selectedValue)) {
        this.form[fieldName] = selectedValue
        return
      }
      if (typeof selectedValue === 'string' || typeof selectedValue === 'number') {
        this.form[fieldName] = selectedValue
        return
      }
      if (typeof selectedValue === 'object' && selectedValue.hasOwnProperty('value')) {
        this.form[fieldName] = selectedValue.value
        return
      }
      this.clearField(fieldName)
    },
    handleInputUpdate (fieldName, inputedValue) {
      if (inputedValue) {
        this.form[fieldName] = inputedValue.hasOwnProperty('value')
          ? inputedValue.value
          : inputedValue
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputDateUpdate (fieldName, inputedValue) {
      if (inputedValue) {
        let newDate = new Date(inputedValue)
        this.form[fieldName] = newDate
      } else {
        this.clearField(fieldName)
      }
    },
    clearField (fieldName) {
      this.form[fieldName] = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/reports/movimentacao/search/SidebarRelatorioMovimentacao.vue